import * as d3 from "d3";
function drawGridlines(chart, xScale, yScale, xTickValues, yTickValues, innerWidth, innerHeight, xMajorTickInterval, yMajorTickInterval) {
    // Horizontal gridlines - Minor ticks
    chart.append("g").attr("class", "y-grid-minor").selectAll("line").data(yTickValues.filter((_, i)=>i % yMajorTickInterval !== 0)) // Minor ticks only
    .enter().append("line").attr("x1", 0).attr("x2", innerWidth).attr("y1", (d)=>yScale(d)).attr("y2", (d)=>yScale(d)).attr("stroke", "#d1d5db").attr("stroke-width", 0.7).attr("stroke-dasharray", "1.5");
    // Vertical gridlines - Minor ticks
    chart.append("g").attr("class", "x-grid-minor").selectAll("line").data(xTickValues.filter((_, i)=>i % xMajorTickInterval !== 0)) // Minor ticks only
    .enter().append("line").attr("x1", (d)=>xScale(d)).attr("x2", (d)=>xScale(d)).attr("y1", 0).attr("y2", innerHeight).attr("stroke", "#d1d5db").attr("stroke-width", 0.7).attr("stroke-dasharray", "1.5");
    // Horizontal gridlines - Major ticks
    chart.append("g").attr("class", "y-grid-major").selectAll("line").data(yTickValues.filter((_, i)=>i % yMajorTickInterval === 0)) // Major ticks only
    .enter().append("line").attr("x1", 0).attr("x2", innerWidth).attr("y1", (d)=>yScale(d)).attr("y2", (d)=>yScale(d))// .attr("stroke", "#8F8E9C")
    // .attr("stroke-width", 0.7)
    // .attr("stroke-dasharray", "0");
    .attr("stroke", "#d1d5db").attr("stroke-width", 0.7).attr("stroke-dasharray", "1.5");
    // Vertical gridlines - Major ticks
    chart.append("g").attr("class", "x-grid-major").selectAll("line").data(xTickValues.filter((_, i)=>i % xMajorTickInterval === 0)) // Major ticks only
    .enter().append("line").attr("x1", (d)=>xScale(d)).attr("x2", (d)=>xScale(d)).attr("y1", 0).attr("y2", innerHeight).attr("stroke", "#8F8E9C").attr("stroke-width", 0.7).attr("stroke-dasharray", "0");
}
function drawLinesAndAreas(chart, datasets, xScale, yScale, innerHeight, clipPathId, gradientIds) {
    datasets.forEach((dataset, i)=>{
        // Convert datetime number to Date object
        const convertedData = dataset.data.map((d)=>({
                ...d,
                x: new Date(d.x)
            }));
        // Define line generator
        const line = d3.line().x((d)=>xScale(d.x)).y((d)=>yScale(d.y));
        // Define area generator
        const area = d3.area().x((d)=>xScale(d.x)).y0(innerHeight).y1((d)=>yScale(d.y));
        // Append line path
        chart.append("g").attr("clip-path", `url(#${clipPathId})`).append("path").datum(convertedData).attr("class", "line").attr("d", line).attr("stroke", dataset.color || "blue").attr("fill", "none");
        // Append area under the line
        chart.append("g").attr("clip-path", `url(#${clipPathId})`).append("path").datum(convertedData).attr("class", "area").attr("d", area).attr("fill", `url(#${gradientIds[i]})`);
    });
}
export { drawGridlines, drawLinesAndAreas };
